<template>
  <div class="mt-1">


    <!-- continue/stop survey: start -->
    <div v-if="!survey.analysis_ordered_at">

      <!-- end testmode: start -->
      <button v-if="survey.testmode" @click="endSurveyTestmode"
      class="text-gray-500  hover:text-markencode-blue outline-none">
      <svg  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
        stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6 outline-none fill-markencode-yellow animate-pulse text-markencode-yellow">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z" />
      </svg>
    </button>
      <!-- end testmode: end -->


      <!-- continue survey: start -->
      <button v-else-if="survey.activated_at == null" @click="toggleSurvey(survey)"
      class="text-gray-500  hover:text-markencode-blue outline-none">
      <svg  v-tooltip.top="'Starten'" xmlns="http://www.w3.org/2000/svg"
        fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6 outline-none fill-markencode-red text-markencode-red">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M5.25 7.5A2.25 2.25 0 0 1 7.5 5.25h9a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25v-9Z" />
      </svg>
      </button>
      <!-- continue survey: end -->


      <button v-else @click="toggleSurvey(survey)"
      class="text-gray-500  hover:text-markencode-blue outline-none">
      <svg  v-tooltip.top="'Stoppen'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
        stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6 outline-none fill-markencode-green animate-pulse text-markencode-green">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z" />
      </svg>
    </button>
    <!-- continue/stop survey: end -->

  </div>

    <!-- already ordered: start -->
    <svg v-if="survey.analysis_ordered_at" v-tooltip.top="`Bestellt am ${this.$options.filters.formatDate(survey.analysis_ordered_at)}`"
      xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
      class="w-6 h-6 outline-none -mt-1 fill-markencode-red text-markencode-red opacity-50">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M5.25 7.5A2.25 2.25 0 0 1 7.5 5.25h9a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25v-9Z" />
    </svg>
    <!-- already ordered: end -->


    <confirm-modal
      v-if="confirmModal.visible"
      @close="confirmModal.visible = false"
      @confirm="endSurveyTestmodeConfirmed"
      class="z-[200]"
    ></confirm-modal>

  </div>
</template>

<script>
import ConfirmModal from '@/Pages/ControlPanel/Workshops/Shared/SurveyTestmodeConfirmModal.vue';

export default {
  components: {
    ConfirmModal,  
  },

  props: {
    survey: {
      type: Object,
      required: false,
      default: () => { },
    },
  },

  data() {
    return {
      confirmModal: {
        visible: false,
      },
    };
  },

  methods: {
    toggleSurvey(survey) {
      this.$inertia.post(this.route('control-panel.workshops.toggle', { sessionUuid: survey.uuid, }), {}, {
        preserveScroll: true,
        preserveState: false,
      });
    },

    endSurveyTestmode() {
      this.confirmModal.visible = true;
    },

    endSurveyTestmodeConfirmed(keepdata) {
      // console.log(keepdata);

      this.confirmModal.visible = false;

      this.$inertia.post(this.route('control-panel.workshops.surveys.end-testmode', { sessionUuid: this.survey.uuid, }), {
        keepdata: keepdata,
      }, {
        preserveScroll: true,
        preserveState: false,
      });

    },
  },
};
</script>